/**
 * 상수
 * @since 0.0.1
 * @author Heungsoo Ham
 * @enum
 */
export enum ConstantKey {
    /** 데이터 스키마 생성 시 대표 컴퍼넌트를 지정하지 않은 경우에 사용될 키 */
    UNDEFINEDCOMPONENT = "undefinedComponent",
    MISSINGCOMPONENT = "missingComponent",
    UNIQUEAPPNAME = "___uniqueAppName",
    VERSIONCURRENT = "___current",
    TESTMODE = "___testMode",
    DEFAULT = "{default}",
    RETRIEVE = "{retrieve}",
    BIZFLOW = "{BizFlow}",
    STATEPREFIXFORGRIDROW = "_gridRow",
    STATEPREFIXFORGRIDROWTRANSIENT = "_gridRowTransient"
}
